import * as React from "react"

import { ChevronDown } from "lucide-react"

import { cn } from "../../cn"

export type ChevronDownIconProps = React.ComponentPropsWithoutRef<
  typeof ChevronDown
>

/**
 * Disclosure chevron shared by every dropdown trigger in the package, so the
 * select, multi-select, and nested-select controls draw the same glyph the
 * breadcrumb chevrons do — same lucide shape, 14px box, muted ink.
 */
const ChevronDownIcon = React.forwardRef<SVGSVGElement, ChevronDownIconProps>(
  ({ className, ...props }, ref) => (
    <ChevronDown
      ref={ref}
      aria-hidden="true"
      className={cn("h-3.5 w-3.5 shrink-0 text-coval-text-muted", className)}
      {...props}
    />
  ),
)

ChevronDownIcon.displayName = "ChevronDownIcon"

export { ChevronDownIcon }
